import React from 'react';
const testimonials = [{
  name: 'Gabriela M.',
  location: 'Miami, FL',
  avatar: 'GM',
  stars: 5,
  text: 'Empecé sin saber absolutamente nada de edición. En mi primera semana conseguí 2 clientes de un spa local. Ya llevo $400 este mes y mis hijos me ven trabajar desde casa. ¡Esto es exactamente lo que necesitaba! 🙌',
  highlight: '$400 en su primer mes'
}, {
  name: 'Valentina R.',
  location: 'Houston, TX',
  avatar: 'VR',
  stars: 5,
  text: 'Tenía miedo de no ser "suficientemente buena". Los scripts de DM que vienen en la guía son oro puro. Mi primer cliente me pagó $150 por 5 Reels simples que me tomaron menos de una hora. No lo podía creer.',
  highlight: '$150 en su primera semana'
}, {
  name: 'Carmen L.',
  location: 'Chicago, IL',
  avatar: 'CL',
  stars: 5,
  text: 'Lo mejor es que nadie sabe que soy yo editando. Trabajo de noche cuando los niños duermen y ya tengo 3 clientes fijos. Esto cambió mi vida y la de mi familia. Gracias por crear algo tan real para nosotras.',
  highlight: '3 clientes fijos en 30 días'
}];
export function Testimonials() {
  return <section className="bg-[#0d4a45] py-16 md:py-24 relative overflow-hidden" data-id="element-368">
      {/* Decorative */}
      <div className="absolute top-0 left-0 w-64 h-64 rounded-full bg-[#c9a84c]/10 -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-369" />
      <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full bg-[#e8a0a0]/10 translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-370" />

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6" data-id="element-371">
        <div className="text-center mb-12" data-id="element-372">
          <span className="font-dm text-xs font-bold tracking-widest text-[#e8a0a0] uppercase" data-id="element-373">
            Resultados reales
          </span>
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mt-3 leading-tight" data-id="element-374">
            Lo que dicen las mamás que ya lo están haciendo
          </h2>
          <p className="font-dm text-white/60 mt-3 text-base" data-id="element-375">
            El secreto mejor guardado de las latinas en USA que trabajan desde
            casa sin descuidar a sus hijos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-376">
          {testimonials.map(t => <div key={t.name} className="bg-[#fdf6ee] rounded-2xl p-6 flex flex-col" data-id="element-377">
              {/* Stars */}
              <div className="flex gap-0.5 mb-4" data-id="element-378">
                {Array.from({
              length: t.stars
            }).map((_, i) => <span key={i} className="text-[#c9a84c] text-lg" data-id="element-379">
                    ★
                  </span>)}
              </div>

              {/* Highlight badge */}
              <div className="inline-flex mb-4" data-id="element-380">
                <span className="bg-[#0d4a45] text-[#e8c97a] text-xs font-dm font-bold px-3 py-1 rounded-full" data-id="element-381">
                  {t.highlight}
                </span>
              </div>

              {/* Quote */}
              <p className="font-dm text-[#3a3a3a] text-sm leading-relaxed flex-1 mb-5" data-id="element-382">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 border-t border-[#0d4a45]/10 pt-4" data-id="element-383">
                <div className="w-10 h-10 rounded-full bg-[#0d4a45] flex items-center justify-center text-white text-xs font-dm font-bold shrink-0" data-id="element-384">
                  {t.avatar}
                </div>
                <div data-id="element-385">
                  <p className="font-dm font-semibold text-[#0d4a45] text-sm" data-id="element-386">
                    {t.name}
                  </p>
                  <p className="font-dm text-[#5a5a5a] text-xs" data-id="element-387">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}